import SpecialOffersContainer from '../../../../components/containers/SpecialOffersContainer';
import preloadCustomProps from '../../../utils/preloads/preloadCarRentalProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'special-offers-container',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: SpecialOffersContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
